import * as Y from 'yjs';
import { canvasRoots, type CanvasBinding, TOP_LEVEL_BINDING } from '../wiring/canvas-roots';

/**
 * Removes one or more edges from `doc.getMap('edges')` inside a single
 * transaction tagged with the clientId — so the per-user UndoManager
 * tracks the deletion as a single atomic step.
 */
export function deleteEdges(doc: Y.Doc, clientId: number, ids: string[], binding: CanvasBinding = TOP_LEVEL_BINDING) {
  if (ids.length === 0) return;
  doc.transact(() => {
    const { edges } = canvasRoots(doc, binding);
    for (const id of ids) edges.delete(id);
  }, clientId);
}
